import { Box, Image } from '@chakra-ui/react'

const checkValue = (value: unknown) =>
  value && typeof value === 'string' && value !== 'false' ? value : undefined

const getBadge = (badge: { image: any; title: any; categoryText: any }) =>
  checkValue(badge?.image) ||
  checkValue(badge?.title) ||
  checkValue(badge?.categoryText)

interface BadgeProps {
  badge: { image: any; title: any; categoryText: any };
  index: number;
}

const Badge = ({ badge, index }: BadgeProps) => {
  return (
    <>
      {getBadge(badge) && index === 0 && (
        <Box position="absolute" top={2} left={2} zIndex={9} maxHeight="20%">
          {checkValue(badge?.image) ? (
            <Box maxW="40%" maxH="50px">
              <Image alt="badge" src={badge.image} />
            </Box>
          ) : (
            <Box py="6px" px={3} bg="white">
              {getBadge(badge)}
            </Box>
          )}
        </Box>
      )}
    </>
  )
}

export default Badge
